export const LIVING_TYPES = {
  INDEPENDENT_LIVING: 1,
  ASSISTED_LIVING: 2,
  MEMORY_CARE: 3,
  ENHANCED_ASSISTED_LIVING: 4,
  SKILLED_NURSING: 5,
};

export const LIVING_TYPES_LABELS = {
  [LIVING_TYPES.INDEPENDENT_LIVING]: 'Independent Living',
  [LIVING_TYPES.ASSISTED_LIVING]: 'Assisted Living',
  [LIVING_TYPES.MEMORY_CARE]: 'Memory Care',
  [LIVING_TYPES.ENHANCED_ASSISTED_LIVING]: 'Enhanced Assisted Living',
  [LIVING_TYPES.SKILLED_NURSING]: 'Skilled Nursing',
};

export const LIVING_TYPES_ABBREVIATIONS = {
  [LIVING_TYPES.INDEPENDENT_LIVING]: 'IL',
  [LIVING_TYPES.ASSISTED_LIVING]: 'AL',
  [LIVING_TYPES.MEMORY_CARE]: 'MC',
  [LIVING_TYPES.ENHANCED_ASSISTED_LIVING]: 'EAL',
  [LIVING_TYPES.SKILLED_NURSING]: 'SN',
};
